import { capitalizeSentenceIfLower } from '@btime/helpers'
import React from 'react'

import { formatBlockReplies } from '../../../../containers/dynamic/presentationList/_helpers/formatBlocks'
import Bar from '../../../../components/pdf/Bar'
import Reply from '../../../../components/pdf/Reply'
import Separator from '../../../../components/pdf/Separator'
import Text from '../../../../components/pdf/Text'

const Replies = ({ replies }) => {
  replies = formatBlockReplies(replies)

  return replies.map(reply => <Reply key={reply.id} reply={reply} />)
}

const RepliesSection = ({ categories }) => {
  return categories.map(category => (
    <div key={category.id}>
      <Separator weight={8} />
      <Bar>
        <Text size="h5" bold>
          {capitalizeSentenceIfLower(category.name)}
        </Text>
      </Bar>

      <Separator weight={4} />

      <Replies replies={category.replies} />
    </div>
  ))
}

export default RepliesSection
